import React from 'react';
import { clientsResource } from '../../helpers/configRoutes/backend_helper';

const Columns = (setModalConfirm, modalConfirm, openModalAdd) => {

    let columns = [
        {
            id: "company_name",
            name: "COMPANY / NAME",
            minWidth: "260px",
            selector: (row) => row.company_name,
            cell: (row) => (
                <div className="flex flex-col">
                    <span className="text-sm font-semibold text-cs-dark leading-tight">
                        {row.company_name || "-"}
                    </span>
                    {row.contact_name && (
                        <span className="text-[10px] text-cs-muted">
                            Contact:{" "}
                            <span className="font-medium text-cs-primary-dark">
                                {row.contact_name}
                            </span>
                        </span>
                    )}
                    {row.phone && (
                        <span className="text-[10px] text-cs-muted">
                            {row.phone}
                        </span>
                    )}
                </div>
            ),
        },
        {
            id: "address",
            name: "ADDRESS",
            minWidth: "260px",
            selector: (row) => row.address,
            cell: (row) => (
                <span className="text-xs text-cs-dark line-clamp-2">
                    {row.address || "-"}
                </span>
            ),
        },
        {
            id: "email_billing",
            name: "BILLING EMAIL",
            minWidth: "220px",
            selector: (row) => row.email_billing,
            cell: (row) => (
                <span className="text-xs text-cs-dark truncate">
                    {row.email_billing || "-"}
                </span>
            ),
        },
        {
            id: "actions",
            name: "",
            right: true,
            minWidth: "120px",
            cell: (client) => {
                const canDelete = !!client.can?.delete;

                return (
                    <div className="flex items-center justify-end gap-2">
                        {/* Edit */}
                        <button
                            type="button"
                            onClick={() => openModalAdd(client)}
                            className="
              p-1.5 rounded-lg
              hover:bg-cs-primary-soft
              text-cs-muted hover:text-cs-primary
              transition-colors
            "
                            title="Edit client"
                        >
                            <span className="material-symbols-outlined text-[18px]">
                                edit
                            </span>
                        </button>

                        {/* Delete */}
                        <button
                            type="button"
                            onClick={() =>
                                canDelete &&
                                setModalConfirm({
                                    ...modalConfirm,
                                    show: true,
                                    id: client.id,
                                })
                            }
                            disabled={!canDelete}
                            className={`
              p-1.5 rounded-lg transition-colors
              ${canDelete
                                    ? "hover:bg-cs-primary-soft text-cs-danger hover:text-cs-danger"
                                    : "opacity-40 cursor-not-allowed text-cs-muted"
                                }
            `}
                            title="Delete client"
                        >
                            <span className="material-symbols-outlined text-[18px]">
                                delete
                            </span>
                        </button>
                    </div>
                );
            },
        },
    ];
    return columns;
}

export default Columns;
